import { RESUME_SCORE_TUTORIAL_FLAG } from './resume-score-tutorial';

// users.options flag that records whether the shorter "what's new" ResumAI scoring tour
// (EN-806) has been shown to an existing user. Deliberately a separate flag from
// RESUME_SCORE_TUTORIAL_FLAG ('builder_passed', EN-805's new-user walkthrough) — reusing that
// flag here would mean this tour never fires for the existing users it targets (they already
// have it set) and would also collide with EN-805's own gating.
export const RESUME_SCORE_WHATS_NEW_TUTORIAL_FLAG = 'resume_score_whats_new_passed';

// Only existing users — people who already completed (or pre-date) the new-user walkthrough,
// i.e. already have `builder_passed` set — and who haven't seen this tour yet are eligible.
// A user who is still going through the new-user tour for the first time (`builder_passed`
// not yet set) is explicitly NOT eligible: they get EN-805's tour instead, and
// modals/builder-onboarding.vue pre-emptively marks this flag on their behalf when that tour
// finishes, so the two tours never both fire for the same person (see the comment there).
export const canShowResumeScoreWhatsNewTutorial = (user) =>
	Boolean(user) && Boolean(user.options?.[RESUME_SCORE_TUTORIAL_FLAG]) && ! user.options?.[RESUME_SCORE_WHATS_NEW_TUTORIAL_FLAG];
